<svg
	class="dropdown-arrow"
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 18 18"
>
	<circle cx="9" cy="9" r="8" class="circle" />
	<path d="M5 8l4 4 4-4z" />
</svg>

<style>
	.dropdown-arrow {
		fill: currentColor;
	}

	.circle {
		fill: currentColor;
		opacity: 0.1;
	}
</style>
